import { createSelector, createFeatureSelector } from '@ngrx/store';
import { LocationManagerState } from './location-manager.reducer';

export const locationManagerState = createFeatureSelector<LocationManagerState>('locationManager');

export const getMapCenterCoords = createSelector(
  locationManagerState,
  (state) => state.mapCenterCoords
);

export const getSearchString = createSelector(
  locationManagerState,
  (state) => state.searchString
);

export const getLoadingSearchResults = createSelector(
  locationManagerState,
  (state) => state.loadingSearchResults
);

export const getAutocompleteResults = createSelector(
  locationManagerState,
  (state) => state.autoCompleteResults
);

export const getLoadedLocation = createSelector(
  locationManagerState,
  (state) => state.loadedLocation
);

export const getMapLoaded = createSelector(
  locationManagerState,
  (state) => state.mapLoaded
);

export const getOffsetLocationMode = createSelector(
  locationManagerState,
  (state) => state.offsetLocationMode
);

export const getAddingNewLocation = createSelector(
  locationManagerState,
  (state) => state.addingNewLocation
);

export const getNewLocationName = createSelector(
  locationManagerState,
  (state) => state.newLocationName
);

export const getHoveredLocation = createSelector(
  locationManagerState,
  (state) => state.hoveredLocation
);

export const getSelectedLocation = createSelector(
  locationManagerState,
  (state) => state.selectedLocation
);

export const getUserLocation = createSelector(
  locationManagerState,
  (state) => state.userLocation
);

export const getGeocodedOffsetLocation = createSelector(
  locationManagerState,
  (state) => state.geocodedOffsetLocation
);
